export default id => id.slice(0, 3) + "..." + id.slice(id.length - 7);
